<template>
  <div class="check_set">
    <h2 class="title_com">考核规则</h2>
    <!-- 提示 -->
    <section class="pd2430">
      <!-- <div class="tips pb24 lh24">
        <span class="c-main">提示：</span>
        <span style="color: #f56c6c; margin: 0 3px 10px"
          >未设置考核规则时，默认结业作业50分、研修日志10分，评价10分，签到30分，迟到/早退扣0分，请假扣0分，未签到扣2分；其他考核项0分；</span
        >
      </div> -->
      <!-- 分数等级 -->
      <div
        style="
          background-color: #f9f9f9;
          padding: 10px 15px 0;
          margin-bottom: 20px;
        "
      >
        <div class="open-header">分数等级</div>

        <el-row :gutter="15">
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            size="small"
            label-width="106px"
          >
            <el-col :span="8">
              <el-form-item label="集中培训满分" prop="full_mark">
                <el-input
                  v-model="form.full_mark"
                  placeholder="请输入满分"
                  clearable
                  :style="{ width: '100%' }"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="及格分数线" prop="pass_mark">
                <el-input
                  v-model="form.pass_mark"
                  placeholder="请输入及格分数线"
                  clearable
                  :style="{ width: '100%' }"
                  @input="inputPassMark"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="优秀分数线" prop="good_mark">
                <el-input
                  v-model="form.good_mark"
                  placeholder="请输入优秀分数线"
                  clearable
                  :style="{ width: '100%' }"
                  @input="inputGoodMark"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <!-- 成绩设置 -->
      <div
        class="score_set"
        style="border: 1px solid #d9d9d9; border-radius: 6px; padding: 10px"
      >
        <section style="display: flex" class="pb24">
          <div style="width: 170px; font-weight: 700">成绩设置：</div>
          <div style="line-height: 32px text-align:justify">
            每项考核只需输入满分，使其总分为集中培训总成绩满分即可，各项考核会按照学员分配到的任务完成率来计算该项得分得分。
            例如评价，满分10分，某个学员收到2个评价，如若只完成1个，得分5.0分，若另外一个学员收到1个评价，并完成1个评价，得分10.0分。
          </div>
        </section>
        <div v-for="(item, index) in tableList" :key="index">
          <div class="examine-top-module">
            {{ item.title }} ({{computeSingleScore(item.data)}}分)
          </div>
          <div>
            <!-- 表格 -->
            <el-table
              :data="item.data"
              ref="table"
              :show-header="false"
              size="mini"
              :row-key="getRowKeys"
              :expand-row-keys="expands"
              @current-change="toggleRowExpansion"
            >
              <!-- 子节点 -->
              <el-table-column type="expand">
                <template slot-scope="scope">
                  <!-- 签到特有 -->
                  <section v-if="scope.row.type == 3">
                    <section
                      style="background-color: #f9f9f9; padding-top: 20px"
                      class="sign_form"
                    >
                      <el-row :gutter="15">
                        <el-form :model="form" size="mini">
                          <el-col :span="8">
                            <el-form-item
                              label="迟到、早退1次扣分："
                              prop="late_min_score"
                              label-width="156px"
                            >
                              <el-input
                                v-model="form.late_min_score"
                                placeholder="请输入"
                                size="mini"
                              >
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item
                              label="请假1次扣分："
                              prop="leave_min_score"
                              label-width="110px"
                            >
                              <el-input
                                v-model="form.leave_min_score"
                                placeholder="请输入"
                                size="mini"
                              />
                            </el-form-item>
                          </el-col>
                          <el-col :span="8" class="col_three">
                            <el-form-item
                              label="未签到（缺勤）1次扣分："
                              prop="lack_min_score"
                              label-width="176px"
                            >
                              <el-input
                                v-model="form.lack_min_score"
                                placeholder="请输入"
                                size="mini"
                              />
                            </el-form-item>
                          </el-col>
                        </el-form>
                      </el-row>
                    </section>
                  </section>
                  <!-- 内嵌表格 -->
                  <el-table
                    :data="scope.row.child_schedule"
                    :show-header="false"
                    size="mini"
                  >
                    <el-table-column label="标题" prop="title" width="360">
                      <template slot-scope="props">
                        <!-- type：40，添加自定义项 -->
                        <span v-if="scope.row.type === 40" key="row-type-40">
                          <el-input
                            v-model="props.row.title"
                            placeholder="请输入"
                            clearable
                            size="mini"
                          />
                        </span>
                        <!-- 否则其他 -->
                        <span v-else key="row-type-no-40">{{
                          props.row.title
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="考核" align="center">
                      <template slot-scope="props">
                        <el-select
                          v-model="props.row.is_check"
                          placeholder="请选择考核 "
                          clearable
                          size="mini"
                          @change="handleChildIsCheck(props.row, scope.row)"
                        >
                          <el-option
                            v-for="(item, index) in is_checkOptions"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column label="地址" align="right">
                      <template slot-scope="props">
                        <span v-if="scope.row.type === 40" key="row-type-40-b"
                          >此项满分：</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column label="参与学员" align="left" width="200">
                      <template slot-scope="props">
                        <!-- 自定义考核特有 -->
                        <span v-if="scope.row.type === 40" key="row-type-40-c">
                          <el-input
                            v-model="props.row.score"
                            placeholder="请输入"
                            clearable
                            size="mini"
                            :style="{ width: '80%' }"
                            :disabled="!props.row.is_check"
                            @input="inputCheckScore(props.row)"
                          />
                          <el-button
                            size="mini"
                            type="text"
                            @click="
                              handleDeleteCustom(
                                props.row,
                                props.$index,
                                scope.row.child_schedule
                              )
                            "
                            :style="{ marginLeft: '10px' }"
                            >删除</el-button
                          >
                        </span>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>

              <el-table-column label="标题" prop="name" width="360">
                <template slot-scope="scope">
                  {{ scope.row.name }}
                  <!-- 签到提示 -->
                  <i
                    class="el-icon-question c-success fs14 ml6 icon"
                    v-if="scope.row.type == 3"
                  >
                    <div class="update-info">
                      <p>提示：此项最低得0分</p>
                    </div>
                  </i>
                  <!-- 资源提示 -->
                  <i
                    class="el-icon-question c-success fs14 ml6 icon"
                    v-else-if="scope.row.type == 6"
                  >
                    <div class="update-info">
                      <p>提示：观看全部或下载即得满分</p>
                    </div>
                  </i>

                  <span v-else-if="scope.row.type == 40">
                    <el-button
                      type="text"
                      @click="handleCreateCustom(scope.row)"
                      style="margin-left: 10px"
                      size="mini"
                      >添加自定义考核项</el-button
                    >
                    <!-- <span class="text-danger">
                      提示：自定义考核项需在成绩管理处录入成绩，否则默认为0分。
                    </span> -->
                    <i class="el-icon-question c-success fs14 ml6 icon">
                      <div class="update-info custom">
                        <p>
                          提示：自定义考核项需在成绩管理处录入成绩，否则默认为0分。
                        </p>
                      </div>
                    </i>
                  </span>
                </template>
              </el-table-column>

              <el-table-column label="考核" align="center">
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.is_check"
                    placeholder="请选择考核 "
                    clearable
                    size="mini"
                    @change="handleIsCheck(scope.row)"
                    v-if="scope.row.type !== 40"
                  >
                    <el-option
                      v-for="(item, index) in is_checkOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                      :disabled="item.disabled"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="地址" align="right">
                <template slot-scope="scope">
                  <span v-if="scope.row.type !== 40" key="row-type-no-x40">
                    此项满分：
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="参与学员" align="left">
                <template slot-scope="scope">
                  <!--不为自定义-->
                  <span v-if="scope.row.type !== 40" key="row-type-no-x40">
                    <el-input
                      v-model="scope.row.score"
                      placeholder="-"
                      clearable
                      size="mini"
                      :disabled="!scope.row.is_check"
                      @input="inputCheckScore(scope.row, scope.$index)"
                    />
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- 确定按钮 -->
      <div class="dialog-footer" style="margin-top: 20px">
        <el-button type="primary" @click="submitForm" size="small"
          >确 定</el-button
        >
        <span style="margin-left: 20px; color: #606266">
          提示：目前已设置<span>{{ totalScore }}</span
          >分，还剩<span>{{ leftScore }}</span
          >分可配置
        </span>
      </div>
    </section>
  </div>
</template>

<script>
import { checkRulesApi, DelCustomItem, SetCheckRules } from "@/api/tearcher";
export default {
  data() {
    return {
      form: {},
      // 表单校验
      rules: {
        full_mark: [
          { required: true, message: "请输入满分", trigger: "blur" },
          { pattern: /^\d+(\.\d+)?$/, message: "请输入数字", trigger: "blur" },
        ],
        pass_mark: [
          { required: true, message: "请输入及格分数线", trigger: "blur" },
          { pattern: /^\d+(\.\d+)?$/, message: "请输入数字", trigger: "blur" },
        ],
        good_mark: [
          { required: true, message: "请输入优秀分数线", trigger: "blur" },
          { pattern: /^\d+(\.\d+)?$/, message: "请输入数字", trigger: "blur" },
        ],
        period: [
          {
            pattern: /^\d+(\.\d{0,1})?$/,
            message: "限定一位小数或整数",
            trigger: "input",
          },
        ],
      },
      tableList: [], // 获取班级考核规则
      expands: [], // 把需要展开的行的id放进去
      class_id: "",
      is_checkOptions: [
        { label: "作为考核", value: 1 },
        { label: "不考核", value: 0 },
      ],
      totalScore: 0, // 已设置分数
      leftScore: 0, // 剩余分数
      iptTimer: null, // 防抖
      tableIndex: 0, //
      is_assignment: true, // 是否赋值操作
      is_fill: false, // 考核项分数必填
    };
  },
  methods: {
    //当表格的当前行发生变化的时候会触发该事件
    toggleRowExpansion(row) {
      this.expands = [];
      this.expands.push(row.id);
    },
    // 获取当前行的id
    getRowKeys(row) {
      return row.id;
    },
    // 计算全部节点的分数
    computeTotalScore() {
      let tableList = [...this.tableList[0].data, ...this.tableList[1].data];
      let totalScore = 0;
      tableList.map((item) => {
        if (Number(item.type) === 40) {
          item.child_schedule.map((item2) => {
            if (item2.is_check === 1) {
              totalScore += Number(item2.score);
            }
          });
        } else if (item.is_check) {
          totalScore += Number(item.score);
        }
      });
      return totalScore;
    },
    // 计算单节点的分数
    computeSingleScore(list) {
      let score = 0;
      list.map((item) => {
        if (Number(item.type) === 40) {
          item.child_schedule.map((item2) => {
            if (item2.is_check === 1) {
              score += Number(item2.score);
            }
          });
        } else if (item.is_check) {
          score += Number(item.score);
        }
      });
      return score;
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          // this.form.id = this.row.id;
          let formPost = { ...this.form };

          let tableList = [...this.tableList[0].data, ...this.tableList[1].data];

          formPost.score_list = tableList;
          formPost.class_id = this.class_id;
          // 集中培训满分
          let totalScore = this.computeTotalScore();
          if (Number(totalScore) !== Number(formPost.full_mark)) {
            this.messageTips("各考核项分数加和需等于满分！请重新设置", "error");
            return false;
          }
          if (this.rulesScore()) {
            this.messageTips("考核项分数不能为空", "error");
            return false;
          }

          if (this.rulesUndefined()) {
            this.messageTips("自定义考核项名称、考核不能为空", "error");
            return false;
          }

          if (Number(this.form.good_mark) > Number(this.form.full_mark)) {
            this.messageTips("优秀分数线需要小于等于满分！", "error");
            return false;
          }

          if (Number(this.form.pass_mark) > Number(this.form.full_mark)) {
            this.messageTips("及格分数线需要小于等于满分！", "error");
            return false;
          }

          SetCheckRules(formPost)
            .then((response) => {
              if (response.error_code === 201) {
                this.messageTips("保存成功", "success");
                // 重新请求班级考核规则
                this.checkRulesApiFn();
              }
            })
            .catch((reason) => {
              console.log(reason);
            });
        }
      });
    },
    // 父级切换 状态
    handleIsCheck(row) {
      if (row.is_check === 0) {
        for (let o of row.child_schedule) {
          o.is_check = 0;
        }
        // 设置当前不能编辑
        row.score = 0;
      } else {
        row.score = 0;
      }
    },
    // 添加自定义 考核项目
    handleCreateCustom(row) {
      //   let $table = this.$refs.table;
      //   $table.toggleRowExpansion(row, true )
      row.child_schedule.push({
        title: "",
        class_id: this.class_id,
        is_check: 0,
        join_type: 1,
        score: 0,
      });
    },
    // 删除自定义 考核项目
    handleDeleteCustom(row, index, chileRow) {
      this.$confirm("是否确认删除该考核项", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      })
        .then(() => {
          if (row.id) {
            return DelCustomItem({ id: row.id });
          }
        })
        .then(() => {
          chileRow.splice(index, 1);
          this.messageTips("删除成功", "success");
        })
        .catch(function () {});
    },
    // 请选择考核
    handleChildIsCheck(row, fatherRow) {
      if (row.is_check === 1 && fatherRow["is_check"] === 0) {
        fatherRow["is_check"] = 1;
        fatherRow.score = 0;
        // 自定义输入框的值
        row.score = 0;
      } else if (row.is_check === 0) {
        // 自定义 不考核设为禁用
        row.score = 0;
      } else {
        row.score = 0;
      }
    },
    // 考核项设置分数
    inputCheckScore(row, index) {
      if (row.score == "") {
        return;
      }
      //   this.tableIndex = index;
      let _this = this;
      // 输入的防抖
      clearTimeout(this.iptTimer); // 清除上一个定时器
      this.iptTimer = setTimeout(function () {
        let rules = /^\d+(\.\d{0,1})?$/;
        if (!rules.test(row.score)) {
          row.score = 0;
          _this.messageTips("请输入整数或保留一位小数", "error");
        } else if (_this.totalScore > _this.form.full_mark) {
          _this.messageTips("设置的分数不可大于总分！", "error");
          row.score = 0;
        } else {
        }
      }, 1000);
    },
    // 及格分数线
    inputPassMark(val) {
      if (Number(val) > Number(this.form.full_mark)) {
        this.messageTips("及格分数线需要小于等于满分！", "error");
        this.form.pass_mark = Number(this.form.full_mark);
      }
    },
    // 优秀分数线
    inputGoodMark(val) {
      if (Number(val) > Number(this.form.full_mark)) {
        this.messageTips("优秀分数线需要小于等于满分！", "error");
        this.form.good_mark = Number(this.form.full_mark);
      }
    },
    // 计算 如果是考核 就必填
    rulesScore() {
      let tableList = [...this.tableList[0].data, ...this.tableList[1].data];
      for (let pl of tableList) {
        // 自定义
        if (Number(pl.type) === 40) {
          for (let plChild of pl.child_schedule) {
            if (plChild.is_check === 1) {
              if (plChild.score === "") {
                return true;
              }
            }
          }
        } else {
          if (pl.is_check === 1) {
            if (pl.score === "") {
              return true;
            }
          }
        }
      }
      return false;
    },
    // 计算 有些值不能为空
    rulesUndefined() {
      let tableList = [...this.tableList[0].data, ...this.tableList[1].data];
      for (let pl of tableList) {
        // 自定义
        if (Number(pl.type) === 40) {
          for (let plChild of pl.child_schedule) {
            if (
              !plChild.title ||
              plChild.is_check === "" ||
              plChild.title === ""
            ) {
              return true;
            }
          }
        }
      }
      return false;
    },
    checkRulesApiFn() {
      checkRulesApi({ class_id: this.class_id, is_convert_layout: 1 }).then((res) => {//, is_convert_layout: 1
        let layout = res.data.layout;
        let tableList = [
          {
            title: "过程性考核",
            data: layout.process
          },
          {
            title: "终结性考核",
            data: layout.final
          }
        ]
        this.tableList = tableList;

        if (res.data.rule) {
          this.form = res.data.rule;
        }
        // 找出自定义考核的数组
        let arr = this.tableList[0].data.filter((item) => {
          // 把不考核的分数置为 '-'
          //   if (!item.is_check) {
          //     item.score = 0;
          //   }
          return item.type == 40;
        });
        // 自定义项默认展开
        if (arr.length > 0) {
          arr.map((item) => {
            this.toggleRowExpansion(item);
          });
        }
      });
    },
    createFn() {
      let class_id = sessionStorage.getItem("class_id");
      if (class_id) {
        this.class_id = class_id;
      }
      // 获取班级考核规则
      this.checkRulesApiFn();
    },
  },
  watch: {
    tableList: {
      deep: true,
      handler(val) {
        console.log(val, "588");
        this.totalScore = this.computeTotalScore();
        let leftScore = Number(this.form.full_mark) - this.totalScore;
        this.leftScore = leftScore.toFixed(1);
      },
    },
  },
  created() {
    this.createFn();
  },
};
</script>
 
<style lang = "less" scoped>
.check_set {
  section {
    .open-header {
      font-size: 18px;
      margin-bottom: 10px;
      color: #303133;
      /* text-indent: 24px; */
    }
    .icon {
      cursor: pointer;
      vertical-align: middle;
      margin-top: -4px;
      .update-info {
        display: none;
        /* width: 238px; */
        color: #334343;
        text-align: left;
        position: absolute;
        top: 0px;
        left: 70px;
        padding: 8px 6px;
        font-size: 12px;
        border-radius: 4px;
        line-height: 22px;
        border: 1px solid #ccc;
        background-color: #f9f9f9;
      }
      .custom {
        top: -60px;
      }

      &:hover {
        .update-info {
          display: block;
        }
      }
    }
    .score_set {
      .sign_form {
        /deep/ .el-form {
          .el-input__inner {
            width: 130px;
          }
          .col_three {
            margin-left: -40px;
          }
        }
      }
    }
  }
}
.examine-top-module {
  height: 40px;
  font-size: 16px;
  color: #333;
  font-weight: bold;
  line-height: 40px;
  margin-top: 20px;
}
</style>